import { render, staticRenderFns } from "./TeamRegistrationForm.vue?vue&type=template&id=33efd71e&scoped=true&"
import script from "./TeamRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./TeamRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./TeamRegistrationForm.vue?vue&type=style&index=0&id=33efd71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33efd71e",
  null
  
)

export default component.exports